/**
 * Prefix of every query key behind a URL test's destination (`['Pages', variables]` and its
 * siblings), for callers invalidating them without holding their variables. Each matches the
 * operation name in its `.gql` file, which is what codegen builds the key from. A destination that is
 * a product is covered by `PLATFORM_PRODUCTS_QUERY_KEY` instead.
 */
export const STOREFRONT_RESOURCE_QUERY_KEYS = ['Pages', 'Collections', 'Articles'] as const;

/**
 * Prefix of the query key each Shopify listing behind a picked page is read under — the lookup a
 * URL test resolves a stored destination with, see `useVariantUrlRedirectLivePages`. Each matches
 * the operation name in its `.gql` file, which is what the key is built from.
 */
export const PICK_PAGE_RESOURCE_QUERY_KEY = {
  PRODUCT: 'PickPageProducts',
  PAGE: 'PickPagePages',
  COLLECTION: 'PickPageCollections',
  ARTICLE: 'PickPageArticles',
} as const;
